import { IStore, store as storeDefault } from '../utils/store';
import { createOfflineStorage } from '../offline-storage';
import { handleFeedbackCheck } from './handleFeedbackCheck';
import { createGaPush } from '../utils/createGaPush';

export async function bootstrap(
  store: IStore = storeDefault,
  global = window,
  localStorageInstance = localStorage
): Promise<void> {

  store.state.gaPush = createGaPush(global);

  const offlineStorage = createOfflineStorage(localStorageInstance);

  handleFeedbackCheck(store, offlineStorage)
    .then(() => console.log('feedback handler finished'))
    .catch((e) => console.error(e));
}
